import React, { Component } from "react";
import * as PropTypes from "prop-types";
import {Button, Checkbox, Col, DatePicker, Drawer, Form, Icon, Input, message, Modal, Row, Spin, Switch, Upload} from "antd";

import { API_ERRO_TYPE_VALIDATION } from "../../config/general";

import { FORM_VALIDATION_MESSAGES } from "../../config/lang";

import { tokensService } from "./../../redux/services";
import moment from "moment/moment";

const FormItem = Form.Item;

class Edit extends Component {
	static propTypes = {
		visible   : PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose   : PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			name: "",
			expiration: null,
		};
	}

	fieldOptions = {
		name: {
			label: "Nome",
			decorator: {
				rules: [{required: true, message: "Campo obrigatório."}],
			},
		},
		token: {
			label: "Token",
		},
		expiration: {
			label: "Validade",
			decorator: {
				defaultValue: null
			},
		},
		permissions: {
			label: "Permissões",
			decorator: {
				defaultValue: []
			},
			options: [
				{label: 'Máquinas e Implementos', value: 'machines'},
				{label: 'Pragas', value: 'pests'},
				{label: 'Doenças', value: 'diseases'},
				{label: 'Ervas Daninhas', value: 'weeds'},
				{label: 'Defensivos', value: 'defensive'},
			]
		}
	};

	onOpen = (id) => {
		this.setState({
			isLoading: true,
			id       : id,
		});

		tokensService.show({id})
		.then((response) => {
			let item = response.data.data;
			this.setState({
				isLoading: false,
			});

			// Fill form
			this.fillForm(item);
		})
		.catch((data) => {
			this.setState({
				isLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: data.error_message,
				onOk   : () => {
					// Force close
					return this.onClose();
				}
			});
		});
	};

	fillForm = (data) => {
		this.props.form.setFieldsValue({
			name     : data.name,
			token   : data.token,
			expiration     : data.expiration? moment(data.expiration) : null,
			permissions: data.permissions || [],
		});
	};

	resetFields = () => {
		this.props.form.resetFields();
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onSubmit = (e) => {
		e.preventDefault();

		this.props.form.validateFieldsAndScroll((error, values) => {
			if( !error )
			{
				this.setState({
					isSending: true,
				});

				const {id} = this.state;
				values.expiration = values.expiration ? moment(values.expiration).format('yyyy-MM-DD') : null;

				// ID
				values.id = id;

				tokensService.edit(values)
				.then(() => {
					this.setState({
						isSending: false,
					});

					// Reset fields
					this.resetFields();

					// Success message
					message.success("Registro atualizado com sucesso.");

					// Callback
					this.props.onComplete();
				})
				.catch((data) => {
					this.setState({
						isSending: false,
					});

					// if validation error
					if( data.error_type === API_ERRO_TYPE_VALIDATION )
					{
						let hasFieldsErrors = false;

						for( let key in data.error_errors )
						{
							if( data.error_errors[key] && this.fieldOptions[key] )
							{
								this.props.form.setFields({
									[key]: {
										value : values[key],
										errors: [new Error(data.error_errors[key])],
									}
								});

								hasFieldsErrors = true;
							}
						}

						if( !hasFieldsErrors )
						{
							Modal.error({
								title  : "Ocorreu um erro!",
								content: data.error_message,
							});
						}
					}
					else
					{
						Modal.error({
							title  : "Ocorreu um erro!",
							content: data.error_message,
						});
					}
				});
			}
		});
	};

	render() {
		const {visible, form}                                                    = this.props;
		const {id, isLoading, isSending, imagePreviewVisible, imagePreviewImage, imageAdsPreviewVisible, imageAdsPreviewImage} = this.state;

		const {getFieldDecorator} = form;

		return (
			<Drawer
				visible={visible}
				className="drawer-form"
				width={"50%"}
				maskClosable={false}
				closable={false}
				keyboard={true}
				placement="right"
				onClose={this.onClose}>
				<Form layout="vertical" onSubmit={this.onSubmit}>
					<div className="form-header">
						<Button className="btn-close" onClick={this.onClose} icon="close" disabled={isLoading || isSending} />
						<div className="ant-drawer-title">{`Editar registro [${id}]`}</div>
						<Button type="primary" htmlType="submit" className="btn-save" icon="check" loading={isSending} disabled={isLoading}>Salvar</Button>
					</div>
					{isLoading ? (
						<div className="text-center" style={{padding: 20}}>
							<Spin indicator={<Icon type="loading" style={{fontSize: 60}} spin />} />
						</div>
					) : (
						<div className="form-body">
							<FormItem label={this.fieldOptions.name.label} hasFeedback>
								{getFieldDecorator("name", this.fieldOptions.name.decorator)(
									<Input />
								)}
							</FormItem>
							<FormItem label={this.fieldOptions.token.label} hasFeedback>
								{getFieldDecorator("token", this.fieldOptions.token.decorator)(
									<Input disabled={true}/>
								)}
							</FormItem>
							<FormItem label={this.fieldOptions.expiration.label} hasFeedback>
								{getFieldDecorator(
									"expiration",
									this.fieldOptions.expiration.decorator
								)(<DatePicker
									disabled={isSending}
									format="DD/MM/YYYY"
									placeholder="Sem validade"
								/>)}
							</FormItem>
							<FormItem label={this.fieldOptions.permissions.label}>
								{getFieldDecorator(
									"permissions",
									this.fieldOptions.permissions.decorator
								)(<Checkbox.Group options={this.fieldOptions.permissions.options}/>)}
							</FormItem>
						</div>
					)}
				</Form>
			</Drawer>
		)
	}
}

export default Form.create({
	validateMessages: FORM_VALIDATION_MESSAGES,
})(Edit);
